import { FC } from "react";
import { RouteDetail } from "./RouteDetail";
import { IRoutesData } from "../types";
import { Link } from "react-router-dom";

export const Routes: FC<IRoutesData> = ({ data }) => {
  return (
    <>
      <h2 className="text-3xl md:text-4xl font-bold text-red-500 mx-6 mt-6 md:mt-10 mb-6">
        {data.title}
      </h2>
      <p className="text-lg mx-6 mb-3">{data.introduction}</p>
      <div className="flex flex-col items-center xs:items-start justify-center mx-6 mb-6 md:mb-3">
        <p className="text-lg">{data.downloadMapsComment}</p>
        <img
          src="/images/routes/mapy-qr.png"
          alt="QR kód pro stažení všech tras"
          className="ml-3 sm:ml-0 h-40 md:h-48"
        />
        <Link
          to={data.mapsPath}
          target="_blank"
          className="text-lg underline hover:text-primary-dark pl-1"
        >
          {data.downloadMapLink}
        </Link>
      </div>
      {data.routeDetails.map((routeDetail, index) => (
        <div key={index}>
          <RouteDetail
            subtitle={routeDetail.subtitle}
            routeDescription={routeDetail.routeDescription}
            downloadMapLink={data.downloadMapLink}
            path={routeDetail.path}
            src={routeDetail.src}
            index={index}
          />
        </div>
      ))}
    </>
  );
};
